import React from "react";
import { Button } from "antd";
import { observer, inject } from "mobx-react";
import { FORM_STEP_MAP } from "../helper/data";
import { AUTH_METHOD_TYPE_MAP } from "@/utils/taxUtil/dict";
import styles from "./index.less";
import { reload } from "@/utils/index";
import SwitchVersion from "@/components/SwitchVersion";

const TaxFormButton = ({
  formStep,
  btnOption,
  isProvince,
  taxHelperStore,
  authMethodType,
  NEW_AUTH,
  needAddTaxOfficer,
}) => {
  const btnText = () => {
    const taxType = taxHelperStore.getTaxType();
    let provinceList = [];
    // 旧版
    if (!NEW_AUTH) {
      provinceList = provinceList.concat(["广东", "山东", "重庆", "湖南", "辽宁", "浙江"]);
    }

    if (isProvince(provinceList)) {
      // needAddTaxOfficer来判断是否需要跳转添加办税员
      if (needAddTaxOfficer !== undefined) {
        return needAddTaxOfficer ? "下一步" : "确认";
      }
      // 否则使用原有逻辑
      return "确认";
    }
    if (formStep === FORM_STEP_MAP.get("first")) {
      return "下一步";
    }
    if (["DZ_ANO", "DZ_WFQ"].includes(taxType)) {
      return "下一步";
    }

    // needAddTaxOfficer来判断是否需要跳转添加办税员
    if (needAddTaxOfficer !== undefined) {
      return needAddTaxOfficer ? "下一步" : "确认";
    }

    return "确认";
  };
  return (
    <div style={{ marginTop: "34px" }}>
      <Button {...btnOption}>{btnText()}</Button>
      <SwitchVersion />
    </div>
  );
};

export default inject("taxHelperStore")(observer(TaxFormButton));

